import React, { useState } from "react";
import { useTranslation } from "react-i18next";



/**
 * Testimonials móvil optimizado para iOS 26
 * - Mismo diseño que desktop
 * - Carrusel móvil simplificado
 */
const MobileTestimonials: React.FC = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      content: t("home.testimonials.testimonial1.content"),
      name: t("home.testimonials.testimonial1.name"),
      role: t("home.testimonials.testimonial1.role"),
      company: t("home.testimonials.testimonial1.company"),
      location: t("home.testimonials.testimonial1.location"),
      image: "/images/testimonial-1.jpg",
    },
    {
      content: t("home.testimonials.testimonial2.content"),
      name: t("home.testimonials.testimonial2.name"),
      role: t("home.testimonials.testimonial2.role"),
      company: t("home.testimonials.testimonial2.company"),
      location: t("home.testimonials.testimonial2.location"),
      image: "/images/testimonial-2.jpg",
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <div className="container mx-auto px-4 py-16 rounded-3xl my-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-[#00342d]">
          {t("home.testimonials.title")}
        </h2>
        <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
          {t("home.testimonials.subtitle")}
        </p>
      </div>

      <div className="relative max-w-4xl mx-auto">
        {/* Carrusel móvil */}
        <div>
           <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center border border-gray-100 relative overflow-hidden">
              {/* Geometric Accent */}
              <div className="absolute top-0 left-0 w-16 h-16 bg-[#e6fffa] rounded-br-full -ml-4 -mt-4 z-0" />
              
              <div className="relative z-10">
                <div className="text-[#00e9be] text-4xl mb-6">
                    <i className="fas fa-quote-left"></i>
                </div>
                <p className="text-lg mb-8 italic text-gray-700 leading-relaxed">"{testimonials[currentSlide].content}"</p>
                <div className="mt-auto">
                    {/* <img
                    src={testimonials[currentSlide].image}
                    alt={testimonials[currentSlide].name}
                    className="w-16 h-16 rounded-full mx-auto mb-4 object-cover border-2 border-[#00e9be]"
                    /> */}
                    <h4 className="text-xl font-bold text-[#00342d]">{testimonials[currentSlide].name}</h4>
                    <p className="text-sm font-medium text-[#00e9be] uppercase tracking-wide mt-1">{testimonials[currentSlide].role}</p>
                    <p className="text-xs text-gray-500 mt-1">{testimonials[currentSlide].company}</p>
                    <p className="text-xs text-gray-400">{testimonials[currentSlide].location}</p>
                </div>
              </div>
            </div>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  index === currentSlide ? "bg-[#00e9be] w-8" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          <div className="flex justify-between mt-6 px-4">
            <button
              onClick={prevSlide}
              className="bg-white text-[#00342d] p-3 rounded-full shadow-md hover:bg-[#e6fffa] transition-colors border border-gray-100"
              aria-label="Previous testimonial"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <button
              onClick={nextSlide}
              className="bg-white text-[#00342d] p-3 rounded-full shadow-md hover:bg-[#e6fffa] transition-colors border border-gray-100"
              aria-label="Next testimonial"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileTestimonials;
